module.exports = new __parcel__URL__("releases-preview.d6e2b061.svg").toString();